import React from "react";
import {flatten} from "lodash";
import {Navigate, useParams} from "react-router-dom";

import {RequiredUserPermissionsSome} from "../../atoms/admin-user-permissions/RequiredUserPermissionsSome";
import {DocumentTitle} from "../../atoms/document-title";
import {ReportingLayout} from "./reporting-layout";
import {ReportContextConsumer} from "./ReportContext";
import {getSectionItemsPermissions} from "./permissions.helpers";
import {
  DEFAULT_GENERAL_SECTION_ID,
  reportingCompletionTime,
  reportingOverview,
  reportingOverviewSection,
  reportingPhotoPayerSourceId,
} from "./constants";
import {Banner} from "../../atoms/banner";
import {getGeneralSectionRenderer} from "./generalReportingSections";
import {reportingListPath} from "./reporting-paths";
import {ReportingListUrlSync} from "./ReportingListUrlSync";

const generalSections = [
  reportingOverview,
  reportingCompletionTime,
  reportingPhotoPayerSourceId,
  reportingOverviewSection,
];

const pagePermissions = getSectionItemsPermissions(
  flatten(generalSections.map(section => section.sectionItems)),
);

export const PageReportingGeneral = () => {
  const {sectionId, from1, to1} = useParams<{
    sectionId: string;
    from1?: string;
    to1?: string;
  }>();
  const Section = sectionId
    ? getGeneralSectionRenderer(sectionId)
    : undefined;

  if (!Section) {
    return (
      <Navigate
        to={reportingListPath("general", DEFAULT_GENERAL_SECTION_ID)}
        replace
      />
    );
  }

  return (
    <ReportingLayout>
      <ReportingListUrlSync from1={from1} to1={to1} />
      <DocumentTitle title={"Reside - Admin - Reporting | General"} />
      <RequiredUserPermissionsSome
        permissions={pagePermissions}
        noPermissionChildren={
          <Banner title="No reports are available for this section.">
            <p>Please choose a different report from the left menu.</p>
          </Banner>
        }
      >
        <ReportContextConsumer>
          {({baseDateRange, activeFacilitiesIds}) => (
            <Section
              baseDateRange={baseDateRange}
              activeFacilitiesIds={activeFacilitiesIds}
            />
          )}
        </ReportContextConsumer>
      </RequiredUserPermissionsSome>
    </ReportingLayout>
  );
};
